import { Provider } from "react-redux";
import { ThemeProvider } from "./ThemeContext"; // добавь
import { RouterProvider } from "react-router-dom";
import "./App.css";
import "./fonts.css";
import { store } from "./store/store";
import Loader from "./components/Loader";
import "react-toastify/dist/ReactToastify.css";
import routes from "routes";
import ThemeModal from "./components/ThemeModal/ThemeModal";
import CookieConsent from "./components/CookieConsent/CookieConsent";

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <Loader>
          <CookieConsent />
          <ThemeModal />
          <RouterProvider router={routes} />
        </Loader>
      </ThemeProvider>
    </Provider>
  );
}

export default App;

// kogaha3417@brinkc.com
// test1234
// 088888888
//https://vlv.am/category/filter/automatic-washing-machines Hisense 99.900